<script setup lang="ts">
import type { NovaBoxBoardListEventItemProps } from './NovaBoxBoardListEventItem.types'
import { ROUTES } from '@configs'

const props = defineProps<NovaBoxBoardListEventItemProps>()
const { date } = useDateFormat()
const { gtEvent } = useGoogleTag()

const goEventDetail = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '이벤트 목록 > 상세보기',
    eventLabel: props.source.nttSj,
    eventSlot: '',
    eventI18nAddr: '',
    eventComponent: 'Button',
    nttGroupId: props.source.nttGroupId,
  })
  useNavigations({
    url: useRoutePathIdChange(ROUTES.BOARD_EVENT_DETAIL.path, {
      id: props.source.nttGroupId,
    }),
  })
  // location.href = useRoutePathIdChange(ROUTES.BOARD_EVENT_DETAIL.path, {
  //   id: props.source.nttGroupId,
  // })
}
</script>

<template>
  <button type="button" class="list-item" @click="goEventDetail">
    <span class="title-box">
      <em class="title">{{ source.nttSj }}</em>
      <em class="date">{{
        date({ date: source.sysRegistDt, format: 'YYYY-MM-DD' })
      }}</em>
    </span>
  </button>
</template>

<style lang="scss" scoped>
.list-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px;
  background-color: $color-white;
  border-radius: $radius-10;
  width: 100%;

  .title-box {
    display: flex;
    flex-direction: column;
    gap: 6px;

    em {
      display: block;
      @include text-style($text-heading3-medium);
    }

    .title {
      @include ellipsis(1);
      text-align: left;
    }
    .date {
      @include text-style($text-body-12-regular);
      line-height: 14px;
      color: $color-text-3;
      text-align: left;
    }
  }
}
</style>
